/**
 * Parse a 'YYYY-MM-DD' string into a LOCAL Date.
 *
 * `new Date('YYYY-MM-DD')` parses as UTC midnight, which can shift the calendar
 * day backwards in negative-offset timezones. Building the Date from local
 * components keeps the intended day, so a calendar view lands on the right date.
 *
 * Returns null for empty or unparseable input.
 */
export function parseLocalDate(value: string): Date | null {
  if (!value) return null
  const parts = value.split('-')
  if (parts.length === 3) {
    const [year, month, day] = parts.map(Number)
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      return new Date(year, month - 1, day)
    }
  }
  const fallback = new Date(value)
  return isNaN(fallback.getTime()) ? null : fallback
}

/**
 * Format a date as a 'YYYY-MM-DD' string using LOCAL components, so it matches
 * the local calendar day and round-trips with parseLocalDate. Defaults to now;
 * accepts an injected date for testing.
 */
export function todayLocalIso(now: Date = new Date()): string {
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
